<section class="{{ sectionProp.class }}" id="{{ sectionProp.id }}">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <ng-content select="[titleSection]"></ng-content>
            </div>
        </div>
        <div class="row">
            
            <div class="col-lg-6">
                <div class="">
                    <img class="img-fluid" class="footer-logo" src="{{ contactDetail.logo }}" alt="img">
                    <br>

                    <!-- <h5 class="mb-3 mt-5" *ngIf="contactDetail.address">{{ contactDetail.address }}</h5> -->
                    <p class="mb-0 mt-3" *ngIf="contactDetail.number">
                        <a href="tel:{{ contactDetail.number }}">{{ contactDetail.number }}</a>
                        
                    </p>
                    <p class="mb-0 mt-3" *ngIf="contactDetail.mail">
                        <a href="mailto:{{ contactDetail.mail }}">{{ contactDetail.mail }}</a>
                        
                    </p>
                    <div class="deatils-social mt-3 mb-2">
                        <ng-content select="[socailLink]"></ng-content>
                    </div>
                    <!-- <h4 class="mb-4">שליחת הודעה למענה מהיר</h4> -->
                    <ng-content select="[contactForm]"></ng-content>
                </div>
            </div>
            <div class="col-lg-6">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3391.638166430256!2d34.63536418484304!3d31.780353381284428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1502a25c6233d327%3A0x8b19905f23608d5e!2z16DXl9ecINep16DXmdeoIDE5LCDXkNep15PXldeT!5e0!3m2!1siw!2sil!4v1642661350163!5m2!1siw!2sil" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6304.829986131271!2d-122.4746968033092!3d37.80374752160443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808586e6302615a1%3A0x86bd130251757c00!2sStorey+Ave%2C+San+Francisco%2C+CA+94129!5e0!3m2!1sen!2sus!4v1435826432051" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</section>